import { useRef } from 'react';
import { Route, Switch } from 'react-router-dom';
import CentralSwitch from 'flow/route-components/CentralSwitch';
import ContactPage from 'flow/route-components/ContactPage';
import ExternalContact from 'flow/route-components/ExternalContact';
import InviteColleagues from 'flow/route-components/InviteCollegues';
import ExtensionCalendar from 'flow/route-components/ExtensionCalendar';
import ThirdPartyContact from 'flow/route-components/ThirdPartyContact';
import { routes } from 'flow/types/routes';
import Settings from 'flow/pages/ai-coworker/Settings';
import General from 'flow/pages/ai-coworker/General';
import Modes from 'flow/pages/ai-coworker/Modes';
import ProfilePage from 'flow/components/Setting/Profile';
import AiCoworker from 'flow/pages/AiCoworker';
import useEscapeReturnsToContactList from 'flow/hooks/useEscapeReturnsToContactList';

const ExtensionsRoutes = () => {
    const cardRef = useRef<HTMLDivElement>(null);
    useEscapeReturnsToContactList(cardRef);

    return (
        <div ref={cardRef} className="contents">
            <Switch>
                <Route
                    path={routes['ai-coworker.settings.modes.profileKey']}
                    component={ProfilePage}
                />
                <Route
                    path={routes['ai-coworker.settings.modes']}
                    component={Modes}
                />
                <Route
                    path={routes['ai-coworker.entityKey.contact']}
                    component={AiCoworker}
                />

                <Route
                    path={routes['extensions.contact.contactKey']}
                    component={ExternalContact}
                />
                <Route
                    path={routes['extensions.entityKey.contact.calendar']}
                    component={ExtensionCalendar}
                />
                <Route
                    path={routes['extensions.entityKey.contact']}
                    component={ContactPage}
                    exact={true}
                />
                <Route
                    path={routes['extensions.invite']}
                    component={InviteColleagues}
                />
                <Route
                    path={
                        routes[
                            'extensions.thirdpartycontact.thirdPartyContactKey'
                        ]
                    }
                    component={ThirdPartyContact}
                />

                <Route
                    path={[routes['extensions.overview'], '/']}
                    component={CentralSwitch}
                />
            </Switch>
        </div>
    );
};

export default ExtensionsRoutes;
